export const API = "tripli-api.inomjonov.site";
